<template>
  <div class="scorecard-modal-backdrop">
    <div id="scorecard_modal" class="scorecard-modal" v-if="scorecard != null">
      <div class="scorecard-scrollbox has-text-centered">

        <div class="game-summary" v-if="scorecard.rounds.length > 0 || scorecard.sets.length > 0">
          <div class="game-summary-heading">
            <span class="is-size-3 has-text-left">
              <img class="game-summary-heading-logo" :src="`${publicPath}img/Axes2-text-logo-sm.png`"/>
            </span> 
            <span class="is-size-3 is-pulled-right has-text-right btn-close"><a class="scorecard-header-close" @click="close"><i class="fas fa-times-circle"></i></a></span>
          </div>
          <div v-if="scorecard.weather !=  null && scorecard.weather[0] != null " class="weather_container">
            <table border="0">
              <tr>
                <td style="padding-top: 10px; width: 90%;" v-if="scorecard.weather.main != null && scorecard.weather.sys != null">
                  <b>{{ scorecard.weather.name }} {{ scorecard.weather?.sys?.country }}</b>
                  {{ (Math.round(scorecard.weather.main.temp)) }}C
                </td>
                <td rowspan="2">
                  <img v-bind:src="'http://openweathermap.org/img/w/' + scorecard.weather.weather[0].icon + '.png'" /> 
                </td>
              </tr>
              <tr>
                <td style="font-style: italic;">
                  {{ scorecard.weather.weather[0].description }}, wind {{ Math.round(scorecard.weather.wind.speed) }}km/h
                </td>
              </tr>
            </table>
          </div>
          <div v-if="scorecard.mood != null 
            && 
            (
              (scorecard.mood.feel != null && scorecard.mood.feel != '') 
              || (scorecard.mood.focusText != null && scorecard.mood.focusText != '') 
              || (scorecard.mood.changedText != null && scorecard.mood.changedText != '')
            ) 
            && isScorecardUser(scorecard.subscriber)">
            <div class="mood_container has-text-left">
              <p class="has-text-6 has-text-weight-bold" style="margin-bottom: 10px;">Personal Sports Journal</p>
              <div v-if="scorecard.mood.feel != null && scorecard.mood.feel != ''" style="margin-bottom: 10px;">
                <p class="is-size-7"><b>I Feel:</b> 
                  <span class="is-size-5">
                    <span v-if="scorecard.mood.feel == 'bad'">
                      <i class="fa-solid fa-face-frown" style="color: red;"></i> 
                    </span>
                    <span v-if="scorecard.mood.feel == 'neutral'">
                      <i class="fa-solid fa-face-meh" style="color: goleenrod;"></i> 
                    </span>
                    <span v-if="scorecard.mood.feel == 'good'">
                      <i class="fa-solid fa-face-smile" style="color: green;"></i> 
                    </span>
                  </span>
                </p>
              </div>
              <div v-if="scorecard.mood.focusText != null" style="margin-bottom: 10px;">
                <p class="is-size-7">
                  <b>My goal is:</b> {{ scorecard.mood.goalText }}
                </p>
              </div>
              <div v-if="scorecard.mood.focusText != null" style="margin-bottom: 10px;">
                <p class="is-size-7">
                  <b>My focus:</b> {{ scorecard.mood.focusText }}
                </p>
              </div>
              <div v-if="scorecard.mood.workingNotesText != null" style="margin-bottom: 10px;">
                <p class="is-size-7">
                  <b>Working Notes:</b> {{ scorecard.mood.workingNotesText }}
                </p>
              </div>
            </div>
          </div>
          <div>
            <div v-if="scorecard.gameType === GameType.ROUNDROBIN || scorecard.gameType === GameType.TOURNAMENT">
              <div v-for="player in scorecard.players" v-bind:key="player.id">
                  <!--
                  <span class="has-text-left">
                    <img class="is-rounded game-summary-user-picture" :src="player.picture">
                  </span>
                  -->
                  <span class="has-text-right is-size-5 game-summary-username">{{ player.name }}</span>
              </div>
            </div>
          </div>
          <div>
            <p class="has-text-centered is-size-6 game-summary-datetime">{{ scorecard.dateTimeStamp  | formatDate }}</p>
            <p v-if="scorecard.title != null">{{ scorecard.title }}</p>
          </div>
          <div>

            <div v-if="scorecard.gameType === GameType.TOURNAMENT">
              <div v-for="(set, index) in scorecard.sets" :key="set.uniqueId">
                <br/>
                <p class="game-summary-round is-size-4 has-text-left has-text-weight-bold">
                  <span v-if="set.type === 'Finals'">Finals </span>
                  Set {{index+1}}</p>
                <div v-for="(round,index) in set.rounds" :key="round.uniqueId">
                  <ScorecardRound :gameType="scorecard.gameType" :index="index" :round="round"/>
                </div>
              </div>
            </div>
            <div v-else>
              <div v-for="(round,index) in scorecard.rounds" :key="round.id">
                <ScorecardRound :gameType="scorecard.gameType" :index="index" :round="round"/>
              </div>
            </div>

            <div>
              <p v-if="scorecard.axe != null && scorecard.axe != ''">Axe: {{ scorecard.axe }}</p>
              <span v-if="scorecard.country != null && scorecard.country != ''">
                <country-flag v-bind:country='scorecard.country' size='big' rounded/>
              </span>
            </div>

          </div>
          <div v-for="(player, index) in scorecard.players" :key="index">
            <div style="width: 80%; margin: auto; margin-top: 20px;">
              <div class="is-size-4">{{ player.name }}</div>
              <div class="is-size-5">Game</div>
              <div class="is-size-6">Avg: {{ $parent.calculateAverageThrow(player,scorecard) }}, Total: {{ $parent.calculateTotalThrows(player,scorecard) }}, Throws: {{ $parent.calculateThrows(player, scorecard) }}</div>
              <div v-if="scorecard.gameType === GameType.TOURNAMENT || scorecard.gameType === GameType.ROUNDROBIN">
                <div class="is-size-5">Finals</div>
                <div class="is-size-6">Avg {{ $parent.calculateAverageThrowFinals(player,scorecard) }}, Total: {{ $parent.calculateTotalThrowsFinals(player,scorecard) }}, Throws: {{ $parent.calculateThrowsFinals(player,scorecard) }}</div>
              </div>
              <div style="width: 250px; margin: auto; margin-top: 20px;" class="has-text-left">
                <vue-bar-graph
                  :points=throwPoints(player,scorecard)
                  :show-x-axis="true"
                  :show-y-axis="false"
                  :width="270"
                  :height="130"
                  :labels="['0','1', '2', '3', '4', '5']"
                  :show-values="true"
                />
              </div>
              <br/>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueBarGraph from 'vue-bar-graph';
import ScorecardRound from "./ScorecardRound.vue";
import { GameType } from '@/enum/gameType.js';

export default {
  name: "ScorecardModal",
  props: {
      scorecard: null
  },
  components: {
      VueBarGraph,
      ScorecardRound
  },  
  data () {
    return {
      GameType,
      publicPath: process.env.BASE_URL,
    }
  },
  methods: {
    isScorecardUser: function(email) {
      console.log("email", email);
      console.log("this.$parent.$auth", this.$parent.$auth);
      if (this.$parent.$auth != null && this.$parent.$auth.user != null && this.$parent.$auth.user.email != null) {
        if (email == this.$parent.$auth.user.email) return true;
        return false;
      }
      return false;
    },
    throwPoints: function (player, scorecard) {
      var arr = [];
      arr.push({label: '0', value: this.calculateAxeHit(player, scorecard, 0)});
      arr.push({label: '1', value: this.calculateAxeHit(player, scorecard, 1)});
      arr.push({label: '2', value: this.calculateAxeHit(player, scorecard, 2)});
      arr.push({label: '3', value: this.calculateAxeHit(player, scorecard, 3)});
      arr.push({label: '4', value: this.calculateAxeHit(player, scorecard, 4)});
      arr.push({label: '5', value: this.calculateAxeHit(player, scorecard, 5)});
      return arr;
    },
    calculateTotalThrowsAxes2: function(throws) {
      var total = 0;
      for(var i = 0; i < throws.length; i++) {
        total += parseInt(throws[i].basicScore)*parseInt(throws[i].basicScore);
      }
      return total;
    },
    calculateThrows: function(player, scorecard) {
        var playerId = player.id;
        var throws = 0;

        if (scorecard.sets != null && scorecard.sets.length > 0) {
          for (var z = 0; z < scorecard.sets.length; z++) {
            var st = scorecard.sets[z];
            for(var x = 0; x < st.rounds.length; x++) {
              var round = st.rounds[x];
              for (var y = 0; y < round.matches.length; y++) {
                var match = round.matches[y];
                for (var t = 0; t < match.matchPlayers.length; t++) {
                  var matchPlayer = match.matchPlayers[t];
                  var matchPlayerId = matchPlayer.player.id;
                  if (matchPlayerId == playerId) {
                    for (var a = 0; a < matchPlayer.throws.length; a++) {
                      throws ++;
                    }
                  }
                }
              }
            }
          }
        } else if (scorecard.rounds != null && scorecard.rounds.length > 0) {
          for(var x = 0; x < scorecard.rounds.length; x++) {
            var round = scorecard.rounds[x];
            for (var y = 0; y < round.matches.length; y++) {
              var match = round.matches[y];
              for (var z = 0; z < match.matchPlayers.length; z++) {
                var matchPlayer = match.matchPlayers[z];
                var matchPlayerId = matchPlayer.player.id;
                if (matchPlayerId == playerId) {
                  for (var a = 0; a < matchPlayer.throws.length; a++) {
                    throws ++;
                  }
                }
              }
            }
          }
        }
        return throws;
    },
    calculateRounds: function(player, scorecard) {
      var rounds = 0;
      if (scorecard.rounds != null) {
        rounds = scorecard.rounds.length;
      }
      return rounds;
    },
    calculateAxes2: function (player, scorecard) {
        var playerId = player.id;
        var total = 0;
        for(var x = 0; x < scorecard.rounds.length; x++) {
            var round = scorecard.rounds[x];
            if (round.title != "Practice") {
                for (var y = 0; y < round.matches.length; y++) {
                    var match = round.matches[y];
                    for (var z = 0; z < match.matchPlayers.length; z++) {
                        var matchPlayer = match.matchPlayers[z];
                        var matchPlayerId = matchPlayer.id;
                        if (matchPlayerId == playerId) {
                            for (var a = 0; a < matchPlayer.throws.length; a++) {
                                var pThrow = matchPlayer.throws[a];
                                //console.log("............pThrow " + pThrow.basicScore);
                                total += parseInt(pThrow.basicScore) * parseInt(pThrow.basicScore);
                            }
                        }
                    }
                }
            }
        }
        return total;
    },
    calculateTotalThrows: function(player, scorecard) {
      //refactor
      var playerId = player.id;
      var total = 0;

      if (scorecard.sets != null && scorecard.sets.length > 0) {
        for (var z = 0; z < scorecard.sets.length; z++) {
          var set = scorecard.sets[z];
          for(var x = 0; x < set.rounds.length; x++) {
            var round = set.rounds[x];
            for (var y = 0; y < round.matches.length; y++) {
              var match = round.matches[y];
              for (var z = 0; z < match.matchPlayers.length; z++) {
                var matchPlayer = match.matchPlayers[z];
                var matchPlayerId = matchPlayer.player.id;
                if (matchPlayerId == playerId) {
                  total += this.calculateTotalThrowsMatch(matchPlayer.throws)
                }
              }
            }
          }
        }
      } else if (scorecard.rounds != null && scorecard.rounds.length > 0) {
        for(var x = 0; x < scorecard.rounds.length; x++) {
          var round = scorecard.rounds[x];
          for (var y = 0; y < round.matches.length; y++) {
            var match = round.matches[y];
            for (var z = 0; z < match.matchPlayers.length; z++) {
              var matchPlayer = match.matchPlayers[z];
              var matchPlayerId = matchPlayer.player.id;
              if (matchPlayerId == playerId) {
                total += this.calculateTotalThrowsMatch(matchPlayer.throws)
              }
            }
          }
        }
      }
      return total;
    },
    calculateTotalThrowsMatch: function(throws) {
        var total = 0;
        for (var a = 0; a < throws.length; a++) {
            var pThrow = throws[a];
            //console.log("............pThrow " + pThrow.basicScore);
            total += parseInt(pThrow.basicScore);
        }
        return total;
    },
    calculateAverageThrowsMatch: function(throws) {
        var total = 0;
        for (var a = 0; a < throws.length; a++) {
            var pThrow = throws[a];
            //console.log("............pThrow " + pThrow.basicScore);
            total += parseInt(pThrow.basicScore);
        }
        var average = total / throws.length;
        var roundedAverage = (Math.round(average * 100) / 100);
        return roundedAverage;
    },
    calculateAxeHitOnRound: function(playerId, round, basicScore) {
      var calculateThisRound = true;
      if (round.title !== undefined && round.title == 'Practice') calculateThisRound = false; 
      var total = 0;
      if (calculateThisRound) {
          for (var y = 0; y < round.matches.length; y++) {
              var match = round.matches[y];
              for (var z = 0; z < match.matchPlayers.length; z++) {
                  var matchPlayer = match.matchPlayers[z];
                  var matchPlayerId = matchPlayer.player.id;
                  //console.log("matchPlayerId", matchPlayerId);
                  if (matchPlayerId == playerId) {
                      for (var a = 0; a < matchPlayer.throws.length; a++) {
                        //throws = matchPlayer.throws.length;
                        var pThrow = matchPlayer.throws[a];
                        //console.log("............pThrow " + pThrow.basicScore);
                        var bScore = parseInt(pThrow.basicScore);
                        if (bScore === basicScore) {
                          total++;
                        }
                      }
                  }
              }
          }
      }
      return total;
    },
    calculateAxeHit: function (player, scorecard, basicScore) {
        var playerId = player.id;
        var total = 0;
        var basicScore = parseInt(basicScore);
        var rounds = 0;
        var throws = 0;
        var total_throws = 0;
        //console.log("calculateAxeHit", playerId);
        if (scorecard.sets != null && scorecard.sets.length > 0) {
          for (var z = 0; z < scorecard.sets.length; z++) {
            var set = scorecard.sets[z];
            //console.log("set", set)
            for(var x = 0; x < set.rounds.length; x++) {
              var round = set.rounds[x];
              total += this.calculateAxeHitOnRound(playerId, round, basicScore)
            }
          }
        } else if (scorecard.rounds != null && scorecard.rounds.length > 0) {
          for(var x = 0; x < scorecard.rounds.length; x++) {
            var round = scorecard.rounds[x];
            total += this.calculateAxeHitOnRound(playerId, round, basicScore)
          }
        }

        return total;
        /*
        total_throws = rounds * throws;
        var avg = (total / total_throws)*100;
        
        //var retStr = basicScore + ": " + total + " (" + avg.toFixed(0) + "%)";

        return avg.toFixed(0);
        */
    },
    calculateAverageThrowsOnRound: function (playerId, round) {
      var total = 0;
      var throws = 0;
      var average = 0;

      var calculateThisRound = true;
      if (round.title !== undefined && round.title == 'Practice') calculateThisRound = false; 

      if (calculateThisRound) {
          for (var y = 0; y < round.matches.length; y++) {
              var match = round.matches[y];
              for (var z = 0; z < match.matchPlayers.length; z++) {
                  var matchPlayer = match.matchPlayers[z];
                  var matchPlayerId = matchPlayer.player.id;
                  if (matchPlayerId == playerId) {
                      for (var a = 0; a < matchPlayer.throws.length; a++) {
                          var pThrow = matchPlayer.throws[a];
                          total += parseInt(pThrow.basicScore);
                          throws ++;
                      }
                  }
              }
          }
      }
      if (total != 0) average = total / throws;
      return average;
    },
    calculateRating: function (player, scorecard) {
        var axes2 = this.calculateAxes2(player, scorecard);
        var throws = 0;
        if (scorecard.rounds != null) {
            var rounds = scorecard.rounds;
            var firstRound = rounds[0];
            var firstMatch = firstRound.matches[0];
            var firstPlayer = firstMatch.matchPlayers[0];
            throws = firstPlayer.throws.length;
        } 
        var rating = axes2/throws;
        var roundedRating = (Math.round(rating * 10) / 10);
        return roundedRating;
    },
    calculateTotal: function(player, calcType) {
        var playerId = player.id;
        var total = 0;
        for(var x = 0; x < this.scorecard.rounds.length; x++) {
            var round = this.scorecard.rounds[x];
            
            var addThisRound = false;
            if (round.title != "Practice") {
                if (calcType === "game") {
                    if (round.title.indexOf("Round") != -1) {
                        addThisRound = true;
                    }
                } else if (calcType === "finals") {
                    if (round.title.indexOf("Final") != -1) {
                        addThisRound = true;
                    }
                }
            }
            if (addThisRound) {
                //console.log("Round: " + round.title);
                for (var y = 0; y < round.matches.length; y++) {
                    var match = round.matches[y];
                    //console.log("....Match: " + match.id + " " + match.title);
                    for (var z = 0; z < match.matchPlayers.length; z++) {
                        var matchPlayer = match.matchPlayers[z];
                        //console.log("........matchPlayer " + matchPlayer.id);
                        var matchPlayerId = matchPlayer.id;
                        if (matchPlayerId == playerId) {
                            for (var a = 0; a < matchPlayer.throws.length; a++) {
                                var pThrow = matchPlayer.throws[a];
                                //console.log("............pThrow " + pThrow.basicScore);
                                total += parseInt(pThrow.basicScore);
                            }
                        }
                    }
                }
            }
        }
        return total;
    },
    calculateBullseyes: function(player, calcType) {
        var playerId = player.id;
        var total = 0;
        for(var x = 0; x < this.scorecard.rounds.length; x++) {
            var round = this.scorecard.rounds[x];
            
            var addThisRound = false;
            if (round.title != "Practice") {
                if (calcType === "game") {
                    if (round.title.indexOf("Round") != -1) {
                        addThisRound = true;
                    }
                } else if (calcType === "finals") {
                    if (round.title.indexOf("Final") != -1) {
                        addThisRound = true;
                    }
                }
            }
            if (addThisRound) {
                //console.log("Round: " + round.title);
                for (var y = 0; y < round.matches.length; y++) {
                    var match = round.matches[y];
                    //console.log("....Match: " + match.id + " " + match.title);
                    for (var z = 0; z < match.matchPlayers.length; z++) {
                        var matchPlayer = match.matchPlayers[z];
                        //console.log("........matchPlayer " + matchPlayer.id);
                        var matchPlayerId = matchPlayer.id;
                        if (matchPlayerId == playerId) {
                            for (var a = 0; a < matchPlayer.throws.length; a++) {
                                var pThrow = matchPlayer.throws[a];
                                //console.log("............pThrow " + pThrow.basicScore);
                                if (pThrow.isBullEye) {
                                  total++;
                                }
                            }
                        }
                    }
                }
            }
        }
        return total;
    },
    close() {
      this.$emit("close");
    }
  },
  mounted(){
  }
};
</script>

<style lang="scss" scoped>
.weather_container {
  width: 320px;
  border: solid gray 1px; 
  font-size: 0.8em;
  padding: 5px;
  border-radius: 10px;
  margin: auto;
  margin-bottom: 10px;
}
.mood_container {
  width: 320px;
  border: solid gray 1px; 
  padding: 5px;
  border-radius: 10px;
  margin: auto;
  margin-bottom: 10px;
}
.score-label {
  font-size: 2em;
  padding-right: 20px;
}
.score-total {
}
.throw-box {
  height: 25px;
  padding: 5px;
}
.throw-box-bullseye {
  height: 25px;
  padding: 5px;
}
.throw-box-total {
}
.throw-box-total-axes2 {
}
.axes2-total {
}
.rank-total {
}
h3 {
}
.scorecard-header {
}
.scorecard-header-close {
  color: red !important;
}
.scorecard-modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-Index: 1000;
}
.scorecard-modal {
  font-family: Verdana;
  padding: 5px;
  border-radius: 25px !important;
  background: silver;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  width: 80%;
  height: 80%;
}
.scorecard-scrollbox {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 0px;
}
.game-summary-heading-logo {
  max-height: 70px !important;
  width: 200px;
  height: 70px;
}

.btn-close {
  font-size: 2em;
  padding-left: 10px;
  cursor: pointer;
  font-weight: bold;

  text-align: right;
}


.game-summary {
    color: black;
    background-color: silver;
    width: 100%;
    height: 100%;
    padding: 5px;
}

.game-summary-logo {
    width: 60px;
}
.game-summary-user-picture {
    vertical-align: middle;
    width: 40px;
    border-radius: 10px;
}
.game-summary-round {
    padding-top: 5px;
    padding-bottom: 5px;
    width: 340px;
    margin: auto;
}
.game-summary-heading {
    font-family: '28 Days Later'
}
.game-summary-heading,
.game-summary-username,
.game-summary-round-title {
    font-weight: bold;
    margin-bottom: 10px;
}
.game-summary-datetime {
    padding: 10px;
}
.game-summary-username {
    width: 200px;
    font-size: 0.8em;
    padding-left: 10px;
}
.game-summary-game-avg {
    font-weight: bold;
    margin: auto;
    margin-top: 10px;
    height: 30px;
    width: 340px;
}
.game-summary-game-avg-avg {
    display: inline;
    float: left;
    width: 150px;
}
.game-summary-game-avg-total {
    display: inline;
    float: left;
    width: 160px;
}
</style>